import { useState } from 'react';
import dayjs from 'dayjs';
import { List, ListItemButton } from '@mui/material';
import SubjectIcon from './SubjectIcon/SubjectIcon';
import MarkIcon from './MarkIcon/MarkIcon';
import MarkIconDesc from './MarkIcon/MarkIconDesc';
import CurrMarksChart from './CurrMarksChart';
import PeriodChart from './PeriodChart';
import MarkTypeSelector from './MarkTypeSelector';

function getMjesec(datum) {
  if (!datum) return '';
  const m = dayjs(datum).format('MMM');
  if (m === 'May') return 'Maj';
  if (m === 'Oct') return 'Okt';
  return m;
}

function getDan(datum) {
  if (!datum) return '';
  return dayjs(datum).format('DD');
}

function getAvg(sum, cnt) {
  if (cnt === 0) return '';
  return Math.round((sum / cnt) * 100) / 100;
}

function getTekucaStatistika(marks) {
  const data = [
    { ocjena: '1', 'ukupan broj': 0 },
    { ocjena: '2', 'ukupan broj': 0 },
    { ocjena: '3', 'ukupan broj': 0 },
    { ocjena: '4', 'ukupan broj': 0 },
    { ocjena: '5', 'ukupan broj': 0 },
  ];
  let sum = 0, cnt = 0;
  marks.forEach((mark) => {
    if (['1','2','3','4','5'].includes(String(mark.ocjena))) {
      const o = parseInt(mark.ocjena);
      data[o - 1]['ukupan broj']++;
      cnt++;
      sum += o;
    }
  });
  return { data, avg: getAvg(sum, cnt) };
}

function getUkupnaStatistika(marks) {
  const data = [
    { period: 'I', suma: 0, broj: 0, prosjek: '' },
    { period: 'II', suma: 0, broj: 0, prosjek: '' },
  ];
  marks.forEach((curr) => {
    curr.ocjene?.forEach((mark) => {
      if (!('naziv_cilja' in mark) && ['1','2','3','4','5'].includes(String(mark.ocjena))) {
        const tip = parseInt(mark.id_tipa_ocjene);
        if (tip >= 3 && tip <= 4) {
          const o = parseInt(mark.ocjena);
          data[tip - 3].broj += 1;
          data[tip - 3].suma += o;
        }
      }
    });
  });
  data[0].prosjek = getAvg(data[0].suma, data[0].broj);
  data[1].prosjek = getAvg(data[1].suma, data[1].broj);
  return data;
}

export default function MarksMUI({ marks = [], onRowSelected, onChangeType, type_id, mark_types = [] }) {
  const [selKey, setSelKey] = useState(-1);

  const handleRowSelected = (mark, index) => {
    setSelKey(index);
    onRowSelected(mark);
  };

  return (
    <div className="marks-page-layout">
      <div className="marks-page-selector">
        <MarkTypeSelector mark_types={mark_types} type_id={type_id} onChange={onChangeType} />
      </div>
      <div className="marks-page-table">
        <div className="marks-container">
            <List sx={{ p: 0, m: 0 }}>
              {marks.map((mark, index) => (
                <ListItemButton key={mark.naziv} sx={{ p: 0, m: 0 }}
                  onClick={() => handleRowSelected(mark, index)}>
                  <div className="main-flex-container">
                    <SubjectIcon naziv={mark.naziv} id={mark.idGrupe} />
                    <div className="right-flex-container">
                      <div className="upper-flex-container">
                        <div className="main-text">{mark.naziv}</div>
                      </div>
                      <div className="bottom-flex-container">
                        {!mark.naziv_cilja && <MarkIcon mark={mark.ocjena} />}
                        {mark.naziv_cilja && <MarkIconDesc mark={mark.ocjena} />}
                        <div className="centered-container">{mark.nazivtipa}</div>
                      </div>
                      {mark.naziv_cilja && (
                        <div className="bottom-flex-container top-border">
                          {mark.naziv_cilja}
                        </div>
                      )}
                    </div>
                    <div className="date-container">
                      <div>{getDan(mark.datum)}</div>
                      <div>{getMjesec(mark.datum)}</div>
                    </div>
                  </div>
                </ListItemButton>
              ))}
            </List>
          </div>
      </div>
      <div className="marks-page-charts">
        <div className="chart-container">
          <CurrMarksChart data={getTekucaStatistika(marks)} is_complete={false} />
        </div>
        <div className="chart-container chart-container-mt3">
          <PeriodChart data={getUkupnaStatistika(marks)} />
        </div>
      </div>
    </div>
  );
}
